export default __webpack_public_path__ + "static/our-mission2-150b4fe9710d145689cb74696594ae3c.png";